<template>
  <BittsTooltip
    v-if="issueMessage"
    overlay-class="c-match-issue-flag__popover"
    :mount-to-body="true"
    placement="top"
  >
    <a
      href="https://help.crossbeam.com/en/articles/5246994-flagging-incorrect-matches"
      target="_blank"
      class="inline-flex items-center justify-center min-h-24 min-w-24"
      :aria-label="`${issueMessage} Learn more about flagged matches.`"
      @click.stop
    >
      <FontAwesomeIcon
        :icon="['fak', 'warning']"
        class="c-match-issue-flag__icon"
      />
    </a>
    <template #title>
      {{ issueMessage }} Click warning icon to learn more.
    </template>
  </BittsTooltip>
</template>

<script setup lang="ts">
import { BittsTooltip } from '@crossbeam/bitts';

import { computed } from 'vue';

import useAuth from '@/composables/useAuth';
import { MatchIssue } from '@/types/match_issues';

const { matchIssues } = defineProps<{ matchIssues: MatchIssue[] }>();

const { currentOrg, currentUser } = useAuth();

const selfReportMessage = computed(() => {
  return matchIssues.find((mi) => mi.reporting_user.id === currentUser.value.id)
    ? 'You reported this as an inaccurate match.'
    : null;
});
const orgReportMessage = computed(() => {
  const issue = matchIssues.find(
    (mi) => mi.reporting_organization.id === currentOrg.value.id,
  );
  if (issue) {
    const user = issue.reporting_user;
    return `${user.first_name} ${user.last_name} reported this as an inaccurate match.`;
  }
  return null;
});
const partnerReportMessage = computed(() => {
  const issue = matchIssues[0];
  if (!issue) return null;
  const { reporting_user: user, reporting_organization: org } = issue;
  return (
    `${user.first_name} ${user.last_name} from ${org.name} ` +
    'reported this as an inaccurate match.'
  );
});
const issueMessage = computed(() => {
  return (
    selfReportMessage.value ||
    orgReportMessage.value ||
    partnerReportMessage.value
  );
});
</script>

<style lang="pcss" scoped>
@reference "../../css/theme.css";
.c-match-issue-flag__icon {
  @apply h-12 w-12;
}
</style>

<style lang="pcss">
@reference "../../css/theme.css";
.c-match-issue-flag__popover .ant-tooltip-inner {
  @apply max-w-[260px];
}
</style>
